import { Table } from '@mantine/core';

import { Content } from '@/core/components';

import { formatDecimal } from '@feature/utils';

interface MinStdTotalOverviewProps {
  totalScore: number;
  unfulfilledCriteria: string[];
}

export function MinStdTotalOverview(props: MinStdTotalOverviewProps) {
  const { totalScore, unfulfilledCriteria } = props;
  return (
    <Content type="full">
      <Table variant="vertical">
        <Table.Tbody>
          <Table.Tr>
            <Table.Th fw="500">Total</Table.Th>
            <Table.Td ta="right">{formatDecimal(totalScore)}</Table.Td>
          </Table.Tr>
          <Table.Tr>
            <Table.Th fw="500">Toate condițiile sunt îndeplinite:</Table.Th>
            <Table.Td ta="right">{unfulfilledCriteria?.length > 0 ? 'NU' : 'DA'}</Table.Td>
          </Table.Tr>
          {unfulfilledCriteria?.length > 0 && (
            <Table.Tr>
              <Table.Th fw="500">Criterii neîndeplinite:</Table.Th>
              <Table.Td ta="right">{unfulfilledCriteria.join(', ')}</Table.Td>
            </Table.Tr>
          )}
        </Table.Tbody>
      </Table>
    </Content>
  );
}
